var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmoji2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 120,
    viewBox: "0 0 114 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.0461 43.6683C95.0461 79.9503 113.999 76.6519 113.999 93.1438C113.999 93.1438 113.999 99.7405 106.418 99.7405H7.86289C0.281738 99.7405 0.281738 93.1438 0.281738 93.1438C0.281738 76.6519 19.2346 79.9503 19.2346 43.6683C19.2346 25.4547 36.205 10.6846 57.1404 10.6846C78.0757 10.6846 95.0461 25.4547 95.0461 43.6683Z",
    fill: "#FFAC33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1403 20.5798C63.4207 20.5798 68.512 16.1496 68.512 10.6847C68.512 5.21974 63.4207 0.789551 57.1403 0.789551C50.8599 0.789551 45.7686 5.21974 45.7686 10.6847C45.7686 16.1496 50.8599 20.5798 57.1403 20.5798Z",
    fill: "#FFAC33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1413 119.531C65.5147 119.531 72.3036 113.624 72.3036 106.338H41.979C41.979 113.624 48.7679 119.531 57.1413 119.531Z",
    fill: "#FFAC33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji2);
export default __webpack_public_path__ + "static/media/Emoji-2.684c7517c1bf1f0391bf1e806a6829cd.svg";
export { ForwardRef as ReactComponent };